import { render, staticRenderFns } from "./AcceptedMaterials.vue?vue&type=template&id=742998b6&"
import script from "./AcceptedMaterials.vue?vue&type=script&lang=ts&"
export * from "./AcceptedMaterials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports